module.exports = __webpack_public_path__ + "img/bg.41e53d7d.jpeg";